import { render } from "./HistoryRent.vue?vue&type=template&id=20bff6c9&scoped=true"
import script from "./HistoryRent.vue?vue&type=script&lang=js"
export * from "./HistoryRent.vue?vue&type=script&lang=js"

import "./HistoryRent.vue?vue&type=style&index=0&id=20bff6c9&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-20bff6c9"]])

export default __exports__